<template>
  <div class="container">
    <el-form size="mini" :model="form" inline ref="mainForm" :rules="rules">
      <el-form-item label="转换到" prop="class_id">
        <el-select v-model="form.class_id" placeholder="请选择班级">
          <el-option
            v-for="item in classList"
            :key="item.class_id"
            :label="item.name"
            :value="item.class_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="footer">
      <div class="btns">
        <div class="mwow-button-filled mini" @click="handleClose">取消</div>
        <div class="mwow-button-filled mini success" @click="handleSubmit">
          确定
        </div>
      </div>
    </div>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import conflictDialog from "../log/conflictDialog.vue";
import { studentChangeConflictCheckApi } from "@/api/classSchedule";
import { studentCanJoinList, studentChangeClass } from "@/api/classManagement";

export default {
  components: {
    conflictDialog,
  },
  // @Prop() classId!: number | string;
  // @Prop() visible!: boolean;
  // @Prop() sids!: number[];
  // @Prop() courseId!: number;
  props: ["classId", "visible", "sids", "courseId"],
  data() {
    return {
      classList: {},
      form: {},
      rules: {
        class_id: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
      },
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.courseId) {
        return false;
      }
      studentCanJoinList({
        original_class_id: Number(this.classId),
        course_id: this.courseId,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          this.handleCheckConflict();
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleCheckConflict() {
      studentChangeConflictCheckApi({
        original_class_id: Number(this.classId),
        join_class_id: this.form.class_id,
        student_ids: this.sids,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      studentChangeClass({
        original_class_id: Number(this.classId),
        join_class_id: this.form.class_id,
        course_id: this.courseId,
        student_ids: this.sids,
      }).then((res) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.handleClose();
          this.$emit("change");
        } else {
          if (res.error_code === 21005021) {
            // 避免统计数据统计重复
            this.$alert(res.message, `更换失败`, {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              type: "warning",
            });
          } else {
            this.$message({
              type: "error",
              message: "修改失败!" + res.message,
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select {
  .el-input {
    width: 300px !important;
  }
}
.footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
